/*  ==|== Responsive =============================================================
 Author: James Jackson-South
 twitter : http://twitter.com/James_M_South
 github : https://github.com/ResponsiveBP/Responsive
 Copyright (c),  James Jackson-South.
 Licensed under the MIT License.
 ============================================================================== */

/*! Responsive v4.1.4 | MIT License | responsivebp.com */

import $ from "jquery";

const getDuration = ($element) =>
  {
    const rtransition = /\d+(.\d+)?/;
    return (
      rtransition.test($element.css("transition-duration")) ? $element.css("transition-duration").match(rtransition)[0] : 0
    ) * 1000;
  };

export const redraw = (els: JQuery) =>
  {
    return els.each(function()
    {
      this.offsetWidth;
    });
  };

export const getDataOptions = ($elem: JQuery, filter: unknown[]) =>
  {
    const options = {};
    $.each($elem.data(), function(key, val)
    {
      if (key.indexOf(filter) === 0 && key.length > filter.length) {

        // Build a key with the correct format.
        const length = filter.length,
          newKey = key.charAt(length).toLowerCase() + key.substring(length + 1);

        options[newKey] = val;
      }
    });

    return Object.keys(options).length ? options : $elem.data();
  };

export const supportRtl = () =>
  {
    return !!$("html[dir=rtl]").length;
  };

export const supportTransition = () =>
  {
    /// <summary>Returns a value indicating whether the browser supports CSS transitions.</summary>
    /// <returns type="Boolean">True if the current browser supports css transitions.</returns>

    const transitionEnd = function()
      {
        /// <summary>Gets transition end event for the current browser.</summary>
        /// <returns type="Object">The transition end event for the current browser.</returns>

        const div = document.createElement("div"),
          transEndEventNames = {
            "transition": "transitionend",
            "WebkitTransition": "webkitTransitionEnd",
            "MozTransition": "transitionend",
            "OTransition": "oTransitionEnd otransitionend",
          };

        const names = Object.keys(transEndEventNames),
          len = names.length;

        for (let i = 0; i < len; i++) {
          if (div.style[names[i]] !== undefined) {
            return { end: transEndEventNames[names[i]] };
          }
        }

        // Falsy and provides a common return expression for the function.
        return null;
      };

    return transitionEnd();
  };

export const onTransitionEnd = (
  element: HTMLElement,
  callback: VoidFunction,
) =>
  {
    if (typeof callback !== "function") return;

    const $el = $(element);
    const duration = getDuration($el);
    const error = duration / 10;
    const start = new Date();

    redraw($el);

    if (supportTransition()) {
      $el.one(supportTransition().end, (...args: any[]) =>
      {
        const end = new Date();
        const elapsed = end.getTime() - start.getTime();

        if (elapsed <= error) {
          setTimeout(() =>
          {
            callback.apply(element, args);
          }, duration);
        } else {
          callback.apply(element, args);
        }
      });
    } else {
      callback.apply(element);
    }
  };

export const pseudoUnique = () =>
  {
    /// <summary>Returns a pseudo unique alpha-numeric string of the given length.</summary>
    /// <param name="length" type="Number">The length of the string to return. Defaults to 8.</param>
    /// <returns type="String">The pseudo unique alpha-numeric string.</returns>

    let len = length || 8,
      text = "",
      possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
      max = possible.length;

    if (len > max) {
      len = max;
    }

    for (let i = 0; i < len; i += 1) {
      text += possible.charAt(Math.floor(Math.random() * max));
    }

    return text;
  };

export const keys = {
  SPACE: 32,
  LEFT: 37,
  RIGHT: 39,
};

export const createResponsiveEventsName = (ns: string, da: string) =>
  {
    const einit = "RBPinit" + ns + da;
    const echanged = ["RBPchanged" + ns + da, "shown.r.modal" + da].join(" ");
    const eshow = "show" + ns;
    const eshown = "shown" + ns;

    return { einit, echanged, eshow, eshown };
  };
